import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="act-form"
export default class extends Controller {

  static targets = ["transit", "metered", "reminderType", "reminderOptions", "reminderBasis", "expiryDays", "expiryDaysField", "reminderAgeMonths", "reminderAgeMonthsField"]

  connect() {
    this.reminderTypeChange({ focus: false })
  }

  get transitSelected() {
    return this.transitTargets.find(transit => transit.checked).value == "1"
  }

  get ageBasisSelected() {
    return this.reminderBasisTargets.find(basis => basis.checked)?.value === "age_months"
  }

  transitChange(e) {
    if (this.transitSelected) {
      this.meteredTargets.forEach(metered => metered.disabled = false)
    } else {
      this.meteredTargets.forEach(metered => metered.disabled = true)
      this.meteredTargets[0].checked = true
      this.meteredTargets[1].checked = false
    }
  }

  reminderTypeChange({ focus = true } = {}) {
    if (this.reminderTypeTarget.value == "") {
      this.reminderOptionsTarget.classList.add("hidden")
      this.clearReminderFields()
    } else {
      this.reminderOptionsTarget.classList.remove("hidden")
      this.reminderBasisChange({ focus })
    }
  }

  reminderBasisChange({ focus = true } = {}) {
    if (this.reminderTypeTarget.value == "") return

    if (this.ageBasisSelected) {
      this.showField(this.expiryDaysFieldTarget, false)
      this.showField(this.reminderAgeMonthsFieldTarget, true)
      this.expiryDaysTarget.disabled = true
      this.expiryDaysTarget.required = false
      this.reminderAgeMonthsTarget.disabled = false
      this.reminderAgeMonthsTarget.required = true
      if (focus) this.reminderAgeMonthsTarget.focus()
    } else {
      this.showField(this.expiryDaysFieldTarget, true)
      this.showField(this.reminderAgeMonthsFieldTarget, false)
      this.reminderAgeMonthsTarget.disabled = true
      this.reminderAgeMonthsTarget.required = false
      this.expiryDaysTarget.disabled = false
      this.expiryDaysTarget.required = true
      if (focus) this.expiryDaysTarget.focus()
    }
  }

  clearReminderFields() {
    this.expiryDaysTarget.value = ""
    this.expiryDaysTarget.disabled = true
    this.expiryDaysTarget.required = false
    this.reminderAgeMonthsTarget.value = ""
    this.reminderAgeMonthsTarget.disabled = true
    this.reminderAgeMonthsTarget.required = false
    this.showField(this.expiryDaysFieldTarget, true)
    this.showField(this.reminderAgeMonthsFieldTarget, false)
    this.reminderBasisTargets.find(basis => basis.value === "expiry_days").checked = true
  }

  showField(field, visible) {
    field.classList.toggle("hidden", !visible)
  }

}
